import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import Accounts from '../../../../../accounts';
import { AccountHistoryFileIconModalButton } from './historyComponent';
import { AccountPositionsHistoryFileIconModalButton } from './positionsHistoryComponent';
import { AccountDocumentsFileIconModalButton } from './documentComponent';
import { AccountOrdersFileIconModalButton } from './ordersComponent';

export const FileIconModalButton = (props: {
  service: Accounts.History | Accounts.Documents | Accounts.PositionsHistory | Accounts.Orders,
  hasFileName?: boolean,
  size?: string | number | undefined,
  transform?: ouiStyle.InStyle['transform'],
  color?: ouiStyle.Constants.Colors,
}) => {
  const {
    service,
    hasFileName,
    size,
    transform,
    color,
  } = props;
  if (service === Accounts.History) {
    return (
      <AccountHistoryFileIconModalButton
        hasFileName={hasFileName}
        size={size}
        transform={transform}
        stroke={color}
      />
    );
  }
  if (service === Accounts.Documents) {
    return (
      <AccountDocumentsFileIconModalButton
        hasFileName={hasFileName}
        size={size}
        transform={transform}
        stroke={color}
      />
    );
  }
  if (service === Accounts.PositionsHistory) {
    return (
      <AccountPositionsHistoryFileIconModalButton
        hasFileName={hasFileName}
        size={size}
        transform={transform}
        stroke={color}
      />
    );
  }
  if (service === Accounts.Orders) {
    return (
      <AccountOrdersFileIconModalButton
        hasFileName={hasFileName}
        size={size}
        transform={transform}
        stroke={color}
      />
    );
  }
  return null;
};
